import React, { useState } from "react";
import { TIDS } from "@/constants/testIds";

const empty = () => Array(9).fill(null);

function checkWinner(b) {
  const lines = [
    [0,1,2],[3,4,5],[6,7,8],
    [0,3,6],[1,4,7],[2,5,8],
    [0,4,8],[2,4,6],
  ];
  for (const [a,b1,c] of lines) {
    if (b[a] && b[a] === b[b1] && b[a] === b[c]) return b[a];
  }
  return null;
}

export default function TicTacToe({ state, sendState }) {
  // If parent provides state, use shared (channel) mode. Else, internal local state (hot-seat).
  const [local, setLocal] = useState({ board: empty(), turn: "X" });
  const shared = !!sendState && !!state;
  const board = shared ? (state.board || empty()) : local.board;
  const turn = shared ? (state.turn || "X") : local.turn;

  const update = (nb, nt) => {
    if (shared) sendState({ board: nb, turn: nt });
    else setLocal({ board: nb, turn: nt });
  };

  const winner = checkWinner(board);
  const isDraw = !winner && board.every(Boolean);

  const handleClick = (i) => {
    if (board[i] || winner) return;
    const nb = [...board];
    nb[i] = turn;
    update(nb, turn === "X" ? "O" : "X");
  };
  const reset = () => update(empty(), "X");

  return (
    <div data-testid={TIDS.gameTtt} className="bg-black/60 border border-white/10 rounded-md p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="sc-heading text-xl font-bold">Tic-Tac-Toe</div>
        <div className="text-xs sc-label">
          {winner ? <span className="text-[#10B981]">Winner: {winner}</span> :
           isDraw ? <span className="text-[#F59E0B]">Draw</span> :
           <span>Turn: <span className="text-[#FF3366]">{turn}</span></span>}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 max-w-xs mx-auto">
        {board.map((v, i) => (
          <button
            data-testid={`${TIDS.gameCell}-${i}`}
            key={i}
            onClick={() => handleClick(i)}
            className="aspect-square bg-[#0c0c0e] border border-white/10 hover:border-[#FF3366]/50 text-4xl font-black flex items-center justify-center transition rounded-sm"
            style={{ color: v === "X" ? "#FF3366" : "#00E5FF" }}
          >
            {v}
          </button>
        ))}
      </div>
      <div className="mt-4 text-center">
        <button data-testid={TIDS.gameReset} onClick={reset} className="sc-btn-ghost text-xs">Reset Game</button>
      </div>
    </div>
  );
}
